export default __webpack_public_path__ + "static/media/allCourse.06e1e82c.JPG";